import type { FunkitTheme } from '../theme/toRestyleTheme'

/**
 * An 8-digit token in a gradient stop renders opaque black, so the alpha has to
 * ride on `stop-opacity` and only the solid colour reach the stop.
 */
export const splitColorToken = (token: string) =>
  token.length === 9
    ? { solid: token.slice(0, 7), alpha: parseInt(token.slice(7), 16) / 255 }
    : { solid: token, alpha: 1 }

/** One `<stop>`, with any alpha moved off the colour. */
export const colorStop = (token: string, offset?: number) => {
  const { solid, alpha } = splitColorToken(token)
  const at = offset === undefined ? '' : ` offset="${offset}"`
  return `<stop${at} stop-color="${solid}" stop-opacity="${alpha}"/>`
}

/**
 * Repaints a KYC artwork export's two-stop ramp (Fun Mobile V2, 2812:1236):
 * the host's brand at the top, the text colour at the bottom. The export's own
 * 5–15% opacity is dropped — it makes the symbol vanish on a dark host.
 */
export function tintKycArtwork(
  xml: string,
  theme: FunkitTheme,
  color = theme.content.elements.primary,
) {
  return xml
    .replace(
      '<stop stop-color="currentColor" stop-opacity="0.05"/>',
      colorStop(theme.brand.primary),
    )
    .replace(
      '<stop offset="1" stop-color="currentColor" stop-opacity="0.15"/>',
      colorStop(color, 1),
    )
}
